module.exports = __webpack_public_path__ + "static/media/download_web_option.429d3e10.png";